// src/components/admin/BillingTabs.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/admin/facturation', label: 'Tableau de bord' },
  { to: '/admin/facturation/clients', label: 'Clients' },
  { to: '/admin/facturation/devis', label: 'Devis' },
  { to: '/admin/facturation/factures', label: 'Factures' },
  { to: '/admin/facturation/contrats', label: 'Contrats' },
  { to: '/admin/facturation/prestations', label: 'Prestations' },
  { to: '/admin/facturation/produits', label: 'Produits' },
  { to: '/admin/facturation/rendez-vous', label: 'Rendez-vous' },
  { to: '/admin/facturation/historique', label: 'Historique' },
  { to: '/admin/facturation/parametres', label: 'Paramètres' },
];

function BillingTabs() {
  const navRef = React.useRef(null);
  const SCROLL_KEY = 'billingTabsScrollLeft';

  // Restore saved scroll position when the nav (re)mounts
  React.useLayoutEffect(() => {
    const nav = navRef.current;
    if (!nav) return;
    // Try multiple frames to counter layout shifts
    let tries = 0;
    const restore = () => {
      try {
        const saved = Number(sessionStorage.getItem(SCROLL_KEY) || '0');
        if (!Number.isNaN(saved) && saved >= 0) nav.scrollLeft = saved;
      } catch { }
      if (tries++ < 2) requestAnimationFrame(restore);
    };
    restore();
  });

  // Save on scroll and pre-save desired centered position on tab interactions
  React.useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;
    const computeTarget = (tabEl) => {
      const navWidth = nav.clientWidth;
      const tabWidth = tabEl?.clientWidth || 0;
      const targetLeft = (tabEl?.offsetLeft || 0) - Math.max(0, (navWidth - tabWidth) / 2);
      const maxScroll = Math.max(0, nav.scrollWidth - navWidth);
      return Math.max(0, Math.min(maxScroll, targetLeft));
    };
    const onScroll = () => { try { sessionStorage.setItem(SCROLL_KEY, String(nav.scrollLeft)); } catch { } };
    const onPointerDown = (e) => {
      const tab = e.target && (e.target.closest ? e.target.closest('.billing-tab') : null);
      if (tab) {
        const desired = computeTarget(tab);
        try { sessionStorage.setItem(SCROLL_KEY, String(desired)); } catch { }
      }
    };
    const onClick = (e) => {
      const tab = e.target && (e.target.closest ? e.target.closest('.billing-tab') : null);
      if (tab) {
        const desired = computeTarget(tab);
        try { sessionStorage.setItem(SCROLL_KEY, String(desired)); } catch { }
      } else {
        try { sessionStorage.setItem(SCROLL_KEY, String(nav.scrollLeft)); } catch { }
      }
    };
    nav.addEventListener('scroll', onScroll, { passive: true });
    nav.addEventListener('pointerdown', onPointerDown, true);
    nav.addEventListener('click', onClick, true);
    return () => {
      nav.removeEventListener('scroll', onScroll);
      nav.removeEventListener('pointerdown', onPointerDown, true);
      nav.removeEventListener('click', onClick, true);
    };
  }, []);

  return (
    <div className="billing-tabs">
      <nav ref={navRef} className="billing-tabs-nav" aria-label="Onglets facturation">
        {tabs.map(t => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) => 'billing-tab' + (isActive ? ' active' : '')}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

export default BillingTabs;
